import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { AppService } from '../services/app.service';
import { CustomHeader } from '../models/header.enum';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  let skipSpinner = false;
  const appService = inject(AppService);

  if (req.headers.has(CustomHeader.SkipLoadingHeader)) {
    req.headers.delete(CustomHeader.SkipLoadingHeader);
    skipSpinner = true;
  }

  if (!skipSpinner) {
    appService.pendingRequestCount.update(u => ++u);
  }

  return next(req).pipe(
    finalize(() => {
      if (!skipSpinner) {
        appService.pendingRequestCount.update(u => --u);
      }
    })
  );
}
